import FeatherIcon from 'feather-icons-react';
import React, { ButtonHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

const BackButton = (props: ButtonHTMLAttributes<HTMLButtonElement>) => {
  const { className, onClick, ...otherProps } = props;
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <button
      role="link"
      onClick={e => {
        if (onClick) onClick(e);
        else history.goBack();
      }}
      className={`flex text-gray-500 cursor-pointer ${className || 'mb-4 sm:mb-6'}`}
      {...otherProps}
    >
      <span aria-hidden="true">
        <FeatherIcon icon="arrow-left" className="mr-2" />
      </span>{' '}
      {t('Go back')}
    </button>
  );
};

export default BackButton;
